<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div
      class="topReturnLink w60 cursor fw-600 color0063ea f16 pdb-10"
      @click="goBack"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 凭证 -->
    <div class="mgt-20">
      <el-button type="primary" class="mgb-20" @click="downloadPdf"
        >下载凭证</el-button
      >

      <el-button
        type="primary"
        class="common-button mgb-20"
        v-print="'#NbAllPage'"
        >打印凭证</el-button
      >
      <div class="pinzheng " id="NbAllPage">
        <div class="f32 center fw-600 mgb-30">
          中智永泉智慧水务科技(成都)有限公司审批凭证
        </div>
        <table>
          <thead>
            <tr class="left-align">
              <th class="titleTd">退款信息</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="contTd">订单编号：{{ infoForm.orderNo }}</td>
              <td class="contTd">水卡编号：{{ infoForm.cardNo }}</td>
              <td class="contTd">企业名称：{{ infoForm.companyName }}</td>
            </tr>
            <tr>
              <td class="contTd">分区名称：{{ infoForm.regionName }}</td>
              <td class="contTd">用户电话：{{ infoForm.userPhone }}</td>
              <td class="contTd">
                充值方式：{{
                  infoForm.orderType == 1
                    ? "用户套餐充值"
                    : infoForm.orderType == 2
                    ? "活动套餐充值"
                    : infoForm.orderType == 3
                    ? "活动充值"
                    : infoForm.orderType == 4
                    ? "接卡"
                    : infoForm.orderType == 5
                    ? "套餐过期(扣减余额)"
                    : infoForm.orderType == 6
                    ? "水卡清零(扣减余额)"
                    : infoForm.orderType == 7
                    ? "迁移充值"
                    : infoForm.orderType == 8
                    ? "订单补偿"
                    : infoForm.orderType == 9
                    ? "合伙人提现"
                    : infoForm.orderType == 10
                    ? "首次充值奖励"
                    : infoForm.orderType == 11
                    ? "新用户绑卡奖励"
                    : infoForm.orderType == 13
                    ? "余额转移(增加余额)"
                    : infoForm.orderType == 14
                    ? "余额转移(扣减余额)"
                    :infoForm.orderType == 19
                    ?"小程序活动套餐充值"
                    : scope.row.orderType == 20
                    ? '合伙人套餐充值'
                    : '- -'
                }}
              </td>
            </tr>

            <tr>
              <td class="contTd">退款金额：{{ infoForm.payMoney }}</td>
              <td class="contTd">申请时间：{{ infoForm.createTime }}</td>
              <!-- <td class="contTd">发起时间：{{ infoForm.createTime }}</td> -->
            </tr>
          </tbody>
          <thead>
            <tr class="left-align">
              <th class="titleTd">企业员工初审</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="contTd">审核状态：已通过</td>
              <td class="contTd">审核时间：{{ infoForm.applyTime }}</td>
              <td class="contTd">审核人：{{ infoForm.applyName }}</td>
            </tr>
            <tr>
              <td class="contTd " colspan="3">
                审核备注：{{
                  infoForm.applyMsg.length > 100
                    ? infoForm.applyMsg.substring(0, 100) + "..."
                    : infoForm.applyMsg
                }}
              </td>
            </tr>
          </tbody>

          <thead>
            <tr class="left-align">
              <th class="titleTd">企业管理员复审</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="contTd">审核状态：已通过</td>
              <td class="contTd">审核时间：{{ infoForm.examineTime }}</td>
              <td class="contTd">审核人：{{ infoForm.examineName }}</td>
            </tr>
            <tr>
              <td class="contTd" colspan="3">
                审核备注：{{
                  infoForm.examineMsg.length > 100
                    ? infoForm.examineMsg.substring(0, 100) + "..."
                    : infoForm.examineMsg
                }}
              </td>
              <!-- <div style="display: flex;justify-content: center;">
                    审核备注：{{
                      infoForm.financeMsg.length > 15
                        ? infoForm.financeMsg.substring(0, 15) + "..."
                        : infoForm.financeMsg
                    }}
                  </div> -->
            </tr>
          </tbody>
        </table>
        <img
          class="pinzhengzhang"
          src="../../assets/images/凭证账.png"
          alt=""
        />

        <!--  -->
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import html2pdf from "html2pdf.js";
// 2. 自定义指令，在单业务页面添加
import print from "vue-print-nb";
export default {
  components: {
    breadcrumbs,
  },

  directives: {
    print,
  },
  data() {
    let that = this;
    return {
      tableData: [],
      data: null,
      infoForm: {},
      tableData: [],
      printObject: {
        id: "NBAllPage",
        popTitle: "配置页眉标题", // 打印配置页上方的标题
        extraHead: "打印", // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
        preview: true, // 是否启动预览模式，默认是false
        previewTitle: "预览的标题", // 打印预览的标题
        previewPrintBtnLabel: "预览结束，开始打印", // 打印预览的标题下方的按钮文本，点击可进入打印
        zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback() {
          console.log("正在加载预览窗口！");
          console.log(that.msg, this);
        }, // 预览窗口打开之前的callback
        previewOpenCallback() {
          console.log("已经加载完预览窗口，预览打开了！");
        }, // 预览窗口打开时的callback
        beforeOpenCallback() {
          console.log("开始打印之前！");
        }, // 开始打印之前的callback
        openCallback() {
          console.log("执行打印了！");
        }, // 调用打印时的callback
        closeCallback() {
          console.log("关闭了打印工具！");
        }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted() {
          console.log("点击v-print绑定的按钮了！");
        },
        // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
        // asyncUrl (reslove) {
        //   setTimeout(() => {
        //     reslove('http://localhost:8080/')
        //   }, 2000)
        // },
      },
    };
  },
  created() {
    console.log(this.$route.query, "data");
    this.data = this.$route.query.data;
    this.infoForm = this.data;
    // let yinhang = {
    //   cardName: this.infoForm.cardName,
    //   cardNo: this.infoForm.cardNo,
    //   cardType: this.infoForm.cardType,
    // };
    // this.tableData.push(yinhang);
  },
  computed: {
    truncatedName() {
      // 判断 examineName 是否存在并且长度大于 15
      if (this.infoForm.examineMsg) {
        return this.infoForm.examineMsg.length > 15
          ? this.infoForm.examineMsg.substring(0, 15) + "..."
          : this.infoForm.examineMsg;
      }
      // 如果 examineName 不存在，则检查 financeName
      else if (!this.infoForm.examineMsg && this.infoForm.financeMsg) {
        return this.infoForm.financeMsg.length > 15
          ? this.infoForm.financeMsg.substring(0, 15) + "..."
          : this.infoForm.financeMsg;
      }
      // 如果两个字段都不存在，返回空字符串
      return "";
    },
  },
  methods: {
    downloadPdf() {
      //
      const element = document.getElementById("NbAllPage");
      const opt = {
        // 转换后的pdf的外边距分别为：上: 10px、右: 20px、下: 10px、左:20px
        margin: [0, 0, 0, 0],
        filename: `审批凭证-${this.infoForm.customerName}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 5 },
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      };

      // 调用html2pdf库的方法生成PDF文件并下载
      html2pdf()
        .from(element)
        .set(opt)
        .save();
    },

    goBack() {
      this.$router.push({
        path: "/ordermanagement/topAfter/afterDetail",
        query: {
          data: this.data,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.beizhu {
  border-right: 0;
  width: 100%;
}
.pinzheng {
  background: var(--card-bg);
  width: 960px;
  height: 600px;
  padding: 46px 41px 60px 41px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  .pinzhengzhang {
    position: absolute;
    bottom: 35px;
    right: 100px;
    width: 246px;
    height: 246px;
  }
  .pinzhengzhang2 {
    position: absolute;
    bottom: -30px;
    right: 100px;
    width: 246px;
    height: 246px;
  }
}

// .contTd {
//   width: 439px;
//   height: 40px;
//   //   border: 1px solid #111111;
//   box-sizing: border-box;
// }
// .titleTd {
//   width: 878px;
//   height: 40px;
//   //   border: 1px solid #111111;
//   box-sizing: border-box;
// }
table {
  border-collapse: collapse;
  padding: 10px 0;
}
/deep/ tr {
  border: 1px solid #111111;
  height: 28px;
  padding: 10px 0;
  box-sizing: border-box !important;
}
td {
  border: 1px solid #111111;
  width: 439px;
  height: 28px;
  padding-left: 10px;
}
th {
  padding-left: 10px;
}
.left-align {
  text-align: left;
}
</style>
